export default "__VITE_ASSET__DGzF7dOH__"